import cx from 'classnames'
import * as React from 'react'

import { arrowLeft } from '../../icons'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import NewsTicker from '../NewsTicker/NewsTicker'
import PageLinks from '../PageLinks/PageLinks'
import ServiceMenuDesktop from '../ServiceMenuDesktop/ServiceMenuDesktop'
import styles from './navigationDesktop-style.css'
import { useEffect, useState } from 'react'

const PageLinksComponent = ({ pageLinks }) => {
  if (!pageLinks) return null
  return <PageLinks items={pageLinks} />
}

const BreakingNews = ({ items, header, breakingNewsLink, className }) => {
  if (!items || !header) return null
  return (
    <div className={cx(styles.breakingNewsDesktop, className)}>
      <NewsTicker items={items} header={header} breakingNewsLink={breakingNewsLink} />
    </div>
  )
}

const BackLink = ({ backLink, items }) => {
  if (!backLink) return null
  const backLinkEventMeta = { event: 'back-link' }
  const labelStyle = items ? { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' } : {}
  const backLinkHolderStyle = items ? { width: '200px' } : {}
  const linkStyle = items ? { maxWidth: '185px' } : {}

  return (
    <div className={styles.backLinkHolder} style={backLinkHolderStyle}>
      <Link
        {...backLink}
        styles={linkStyle}
        className={styles.backLink}
        eventMeta={backLinkEventMeta}
      >
        <Icon iconSrc={arrowLeft} className={styles.prevAngle} width="11px" height="11px" />
        <div style={labelStyle}>{backLink.label}</div>
      </Link>
    </div>
  )
}

const BottomBar = ({ backLink, items, header, breakingNewsLink }) => {
  return backLink ? (
    <div className={cx(styles.bottomBar)}>
      <BackLink backLink={backLink} items={items} />
      <BreakingNews items={items} header={header} breakingNewsLink={breakingNewsLink} className={styles.onSide} />
    </div>
  ) : (
    <BreakingNews items={items} header={header} breakingNewsLink={breakingNewsLink} className={styles.full} />
  )
}

const MyPageLink = ({ myPageLink, pageLinks, notificationCount }) => {
  if (!myPageLink || !pageLinks) return null
  return (
    <div className={styles.myPageDiv}>
      <PageLinks items={[myPageLink]} notificationCount={notificationCount} />
    </div>
  )
}

const NavigationDesktop = ({
                             logo,
                             serviceMenu,
                             searchBtn,
                             pageLinks,
                             backLink,
                             items,
                             header,
                             hide,
                             breakingNewsLink,
                             myPageLink,
                             notificationCount,
                             hideBottomDivider,
                             onSubmit,
                             pageLogin,
                             alignLogin,
                           }) => {
  const [dropdownLinks, setDropdownLinks] = useState<React.ReactNode | null>(null)
  const [isOpened, setIsOpened] = useState(false)
  const [lastOpened, setLastOpened] = useState('')
  const ref = React.useRef<HTMLDivElement | null>(null)
  const handleDropdownLinksUpdate = (links: React.ReactNode, title: string) => {
    if (lastOpened === title || !lastOpened) {
      setIsOpened(!isOpened)
    } else {
      setIsOpened(true)
    }
    setLastOpened(title)
    setDropdownLinks(links)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpened(false)
      }
    }

    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpened(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    document.addEventListener('keydown', handleEscKey)

    return () => {
      document.removeEventListener('click', handleClickOutside)
      document.removeEventListener('keydown', handleEscKey)
    }
  }, [])

  if (hide !== null && hide) return null

  return (
    <div className={cx(styles.navigationDesktop, hideBottomDivider ? styles.noDivider : '')} ref={ref}>
      <nav className={styles.mainNavigation}>
        <div className={styles.serviceMenuWrapper}>
          <ServiceMenuDesktop
            links={serviceMenu.links}
            logo={logo}
            renderLogo={!!pageLinks}
            searchBtn={searchBtn}
            onSubmit={onSubmit}
            pageLogin={pageLogin}
            alignLogin={alignLogin}
            onDropdownLinksUpdate={handleDropdownLinksUpdate}
            isOpened={{isOpened, lastOpened}}
          />
        </div>
        <div className={cx(styles.dropdownDrawer,  isOpened ? styles.show : styles.hide)}>
          {isOpened && dropdownLinks}
        </div>
        <div className={cx(styles.pageMenu, pageLinks && styles.margin)}>
          <div className={styles.pageMenuInner}>
            <PageLinksComponent pageLinks={pageLinks} />
            <MyPageLink myPageLink={myPageLink} pageLinks={pageLinks} notificationCount={notificationCount} />
          </div>
        </div>
      </nav>
      <BottomBar
        backLink={backLink}
        items={items}
        header={header}
        breakingNewsLink={breakingNewsLink}
      />
    </div>
  )
}

export default NavigationDesktop